import type { Item } from 'bundles/learner-progress/types/Item';
import {
  getIsLockedByResit,
  getIsLockedForPremiumGrading,
  getIsLockedForSessions,
  getIsLockedFully,
} from 'bundles/learner-progress/utils/Item';

export function isItemLockedToAuditUpgradeFlowUsers(item: Item) {
  // what does "locked" even mean?  ¯\_(ツ)_/¯
  const isLocked =
    getIsLockedFully(item) ||
    getIsLockedForSessions(item) ||
    getIsLockedByResit(item) ||
    getIsLockedForPremiumGrading(item);
  return isLocked && !item.isLockedByPreviousItem;
}
